const FILTER_TYPES = {
    relevant: 'relevant'
};

module.exports = {
    FILTER_TYPES
};
